import React from 'react';
import { formatAreaSqm } from 'utils';

const formatLabel = (val) => {
  if (!val) return '—';
  return val.replace(/_/g, ' ');
};

const GroupDetailsPanel = ({
  group,
  trees = [],
  selectedTreeId,
  selectedTreeIds = [],
  onSelectTree,
  onEditTree,
  onDeleteGroup,
  onRemoveTree,
}) => {
  if (!group) {
    return (
      <div className="empty-state">
        <p>Group not found</p>
      </div>
    );
  }

  const groupTrees = (group.tree_ids || [])
    .map((id) => trees.find((t) => t.tree_id === id))
    .filter(Boolean);

  return (
    <div>
      <div className="panel-section panel-section-header">
        <h2>{group.name}</h2>
        <div className="panel-meta-row">
          <span className="tag" style={{ background: '#e8f5e9', color: '#1a472a' }}>
            {groupTrees.length} trees
          </span>
          {group.area_sqm != null && (
            <span className="tag" style={{ background: '#e8f5e9', color: '#1a472a' }}>
              {formatAreaSqm(group.area_sqm, { alwaysSqm: true })}
            </span>
          )}
        </div>
        <p className="empty-inline" style={{ marginTop: 8, fontSize: 12 }}>
          Map footprint area (polygon on the map, not canopy cover).
        </p>
        {group.centre_lat != null && group.centre_lng != null && (
          <p className="empty-inline" style={{ marginTop: 8, fontSize: 12 }}>
            Centre: {Number(group.centre_lat).toFixed(5)}, {Number(group.centre_lng).toFixed(5)}
          </p>
        )}
        <button
          type="button"
          className="btn btn-danger btn-touch"
          style={{ marginTop: 12, width: '100%' }}
          onClick={() => onDeleteGroup?.(group)}
        >
          Delete group
        </button>
      </div>

      <div className="panel-section">
        <h3>Trees in group</h3>
        {groupTrees.length === 0 && (
          <p className="empty-inline">No trees in this group.</p>
        )}
        {groupTrees.map((t) => {
          const isMulti = selectedTreeIds.includes(t.tree_id);
          const isFocused = selectedTreeId === t.tree_id;
          return (
            <div
              key={t.tree_id}
              className={`job-list-item job-list-item-touch ${isFocused ? 'selected' : ''} ${isMulti ? 'multi-selected' : ''}`}
              onClick={(e) => {
                if (e.shiftKey) {
                  e.preventDefault();
                  onSelectTree?.(t, { shift: true });
                } else {
                  onSelectTree?.(t);
                }
              }}
              role="button"
              tabIndex={0}
              onKeyDown={(e) => {
                if (e.key === 'Enter') onSelectTree?.(t);
              }}
            >
              <div className="job-list-item-row">
                <div className="job-list-item-body">
                  <div className="list-item-headline">
                    <h4>{t.common_name || `${t.genus} ${t.species}`}</h4>
                    <span className="list-item-meta">{formatLabel(t.status)}</span>
                  </div>
                </div>
                <div className="panel-inline-actions">
                  <button
                    type="button"
                    className="btn btn-secondary btn-sm btn-touch-inline"
                    style={{ color: '#333', background: '#eee' }}
                    onClick={(e) => { e.stopPropagation(); onRemoveTree?.(group, t); }}
                  >
                    Remove
                  </button>
                  <button
                    type="button"
                    className="btn btn-secondary btn-sm btn-touch-inline"
                    style={{ color: '#333', background: '#eee' }}
                    onClick={(e) => { e.stopPropagation(); onEditTree?.(t); }}
                  >
                    Edit
                  </button>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default GroupDetailsPanel;
